import {
  BloombergLogo,
  NewsweekLogo,
  ForbesLogo,
  FoxBusinessLogo,
  WSJLogo,
} from 'component-library/components/icons';
import { Flex } from 'component-library/components/layout/Flex';
import { Heading } from 'component-library/components/typography/Heading';
import { Screen, ShowOn } from 'component-library/components/wrappers/ShowOn';
import { colors } from 'component-library/styles/colors';
import React from 'react';
import styled from 'styled-components';

const FeaturedWrapper = styled(ShowOn)`
  border-bottom: 1px solid ${colors.navyBlue};
`;

const FeaturedIn = styled(Heading)`
  padding: 32px;
  border-top: 1px solid ${colors.navyBlue};
  border-bottom: 1px solid ${colors.navyBlue};
  text-align: center;
`;

const Logos = styled(Flex)`
  flex-wrap: wrap;
  padding: 48px 32px;

  svg {
    margin: 20px;
  }
`;

export const FeaturedSmall = () => (
  <FeaturedWrapper screens={[Screen.Sm, Screen.Md, Screen.Lg]}>
    <FeaturedIn variant={5}>Featured In</FeaturedIn>
    <Logos justifyContent="center">
      <ForbesLogo />
      <BloombergLogo />
      <WSJLogo />
      <FoxBusinessLogo />
      <NewsweekLogo />
    </Logos>
  </FeaturedWrapper>
);
